import { EditProjectContextProps } from "../../../EditProjectContext";

export function updateRoutePropertyOnProject(
  propertyName: string,
  value: any,
  routeNumber: string,
  projectState: EditProjectContextProps
) {
  const { project, setProject } = projectState;

  const ftlRoutes = project.FTLRoutes?.map((ftlRoute) => {
    if (ftlRoute.RouteNumber === routeNumber) {
      return { ...ftlRoute, [propertyName]: value };
    }

    return ftlRoute;
  });

  setProject({
    ...project,
    FTLRoutes: ftlRoutes,
  });
}
